import { CSSResultGroup } from 'lit';
import { customElement } from 'lit/decorators.js';
import componentStyles from './idb-bio-card-cta.css.lit';
import { IdbButton } from '../../idb-button/idb-button';

/**
 * The IdbBioCardCta component
 * @element idb-bio-card-cta
 */
@customElement('idb-bio-card-cta')
export class IdbBioCardCta extends IdbButton {
  static styles: CSSResultGroup = [IdbButton.styles, componentStyles];
}
